var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5458 3.19449C18.3798 2.59249 21.4073 3.42099 23.6638 5.21149C24.5768 5.93549 25.3663 6.81849 25.9623 7.82099C27.2893 10.052 27.7148 12.757 27.3898 15.332C27.0648 17.907 26.0228 20.358 24.6098 22.5355C23.5273 24.2035 22.2013 25.7475 20.5363 26.835C18.8713 27.9225 16.8393 28.5255 14.8708 28.241C13.1638 27.9945 11.6048 27.1055 10.2813 26C7.35727 23.5575 5.43077 19.972 4.93977 16.194C4.55777 13.2545 5.07927 10.092 6.91477 7.76499C8.94427 5.19199 12.1928 4.01649 15.2708 3.25749C15.3623 3.23499 15.4538 3.21399 15.5458 3.19449Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0725 4.11652C8.24648 4.27702 2.84298 9.94102 3.00348 16.767C3.15848 23.3675 8.47248 28.681 15.073 28.8365C21.8995 28.8365 28.793 21.9185 28.793 15.1165C28.787 8.84402 22.5585 4.11652 15.0725 4.11652Z",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2529 9.91553C14.2529 9.91553 14.3164 15.474 14.3164 16.047C14.3164 16.62 14.3374 18.4445 15.1014 18.402C15.8654 18.3595 20.8509 17.638 20.8509 17.638",
    stroke: "#393B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon-time.93344aea4bae452d324a2467fc928fe3.svg";
export { ForwardRef as ReactComponent };